// entry point for webpack, can import js here, also creates css files
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFlip, EffectFade } from 'swiper/modules';
// Swiper css and module styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import "./scss/_post-slider.scss";

import breakpointsConfig from './js/breakpoints';

document.addEventListener("DOMContentLoaded", function() {

  var sliders = document.getElementsByClassName('acf-block-post-slider');
  if (sliders.length > 0) {
    new Promise(function(resolve) {
      var columns = sliders[0].getAttribute('data-columns');
      if (columns !== null) {
        resolve(columns);
      } else {
        resolve('columns--2');
      }
    }).then(function(columns) {

      // init Swiper
      const swiper = new Swiper('.swiper-post', {
        modules: [ Navigation, Pagination, Autoplay, EffectFlip, EffectFade ],
        direction: 'horizontal',
        loop: true,
        autoplay: {
          delay: 3000,
        },
        disableOnInteraction: true,
        speed: 1100,
        pagination: {
          el: '.swiper-post-pagination',
          type: 'bullets',
        },
        navigation: {
          nextEl: '.swiper-post-button-next',
          prevEl: '.swiper-post-button-prev',
        },
        breakpoints: breakpointsConfig[columns],
      });
      sliders[0].classList.add('columns-loaded');
    });
  }
} );